import React, { useEffect, useState } from 'react'
import * as S from './styles'
import { ReactComponent as Cookie } from '../../../images/cookie.svg'
import CookiesInformation from '@site/components/molecules/CookiesInformation'

const CookiesFab = (): React.ReactElement => {
  const [ showInformation, setShowInformation ] = useState<boolean>( false )
  const [ showModal, setShowModal ] = useState<boolean>( false )

  const handleOnClose = ( e:React.MouseEvent<HTMLAnchorElement> ) => {
    e.stopPropagation()
    if ( typeof window !== 'undefined' ) {
      localStorage.setItem( 'cookies_accepted', 'true' )
    }
    setShowModal( false )
  }

  const showInfomationCookie = () => setShowInformation( true )

  useEffect( () => {
    if ( typeof window !== 'undefined' && !localStorage.getItem( 'cookies_accepted' ) ) {
      setShowModal( true )
    }
    setTimeout( () => {
      showInfomationCookie()
    }, 5000 )
    window.addEventListener( 'scroll', () => {
      setTimeout( () => {
        showInfomationCookie()
      }, 100 )
    } )
    return () => window.removeEventListener( 'scroll', showInfomationCookie )
  }, [] )

  return (
    <div>
      { showModal &&
        <S.Container
          className="book-metadata-header"
          onClick={ () => setShowInformation( true ) }
          show={ showInformation }
        >
          <Cookie />
          { showInformation && <CookiesInformation onClose={ handleOnClose } /> }
        </S.Container>}
    </div>
  )
}

export default CookiesFab
